import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { storeWindowSize } from '~/redux/actions/global'
import Header from './partials/Header'
import Footer from './partials/Footer'
import Notices from './partials/Notices'
import Register from '@components/Register'
import Newsletter from '@components/Newsletter'
import Toolbar from './partials/Toolbar'
import { isEmail, capitaliseFirstLetter, trackEvent, trackFbEvent, isTel, urlMatchesKeyword, setupTrackEmbeddedFormEvent } from '~/scripts/helpers'

class Main extends Component {
  constructor () {
    super()
    this.emailClickHandler = this.trackEmailEvent.bind(this, 'click')
    this.emailCopyHandler = this.trackEmailEvent.bind(this, 'copy')
    this.telClickHandler = this.trackTelEvent.bind(this, 'click')
    this.telCopyHandler = this.trackTelEvent.bind(this, 'copy')

    this.state = {
      modal: false
    }
  }

  componentDidMount () {
    this.onResize()
    window.addEventListener('resize', this.onResize.bind(this))
    document.addEventListener('click', this.emailClickHandler)
    document.addEventListener('copy', this.emailCopyHandler)
    document.addEventListener('click', this.telClickHandler)
    document.addEventListener('copy', this.telCopyHandler)
    this.trackContactFormEvent()
    this.trackFirstClassFormEvent()
    this.trackNewsletterFormEvent()
    this.showModalOnUrl()

    document.onreadystatechange = function () {
      setupTrackEmbeddedFormEvent()
    }

    const hiddenIframes = document.querySelectorAll('iframe[style*="visibility: hidden"]')
    hiddenIframes.forEach((iframe) => {
      iframe.setAttribute('aria-hidden', 'true')
    })
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this.onResize.bind(this))
    document.removeEventListener('click', this.emailClickHandler)
    document.removeEventListener('copy', this.emailCopyHandler)
    document.removeEventListener('click', this.telClickHandler)
    document.removeEventListener('copy', this.telCopyHandler)
  }

  onResize () {
    this.props.storeWindowSize(window.innerWidth, window.innerHeight)
  }

  toggleModal () {
    const modal = this.state.modal

    this.setState((state) => {
      return { modal: !modal }
    })

    // Temporary until permanent solution found
    document.body.classList.toggle('overflow-y-hidden')
  }

  trackEmailEvent (event, e) {
    const el = e.target
    const action = capitaliseFirstLetter(event)
    const dataLayer = window.dataLayer || []

    if (el.matches('a') && isEmail(el.getAttribute('href'))) {
      trackEvent('lead-pjc-ContactEmail', action, el.textContent)
      trackFbEvent('Contact')
      dataLayer.push({ event: 'enquire_email_view', enquire_email: el.textContent })
    }
  }

  trackTelEvent (event, e) {
    const el = e.target
    const action = capitaliseFirstLetter(event)
    const dataLayer = window.dataLayer || []

    if (el.matches('a') && isTel(el.getAttribute('href'))) {
      trackEvent('lead-pjc-ContactPhone', action, el.textContent)
      trackFbEvent('Contact')
      dataLayer.push({ event: 'enquire_phone_view', enquire_phone: el.textContent })
    }
  }

  trackContactFormEvent () {
    const regex = /\/get-in-touch-enquiry-success/gi
    const dataLayer = window.dataLayer || []

    if (urlMatchesKeyword(regex)) {
      trackEvent('lead-pjc-ContactForm', 'Submit', 'Enquiry')
      trackFbEvent('Contact')
      dataLayer.push({ event: 'enquire_form_submit', form_name: 'Enquiry' })
    }
  }

  trackFirstClassFormEvent () {
    const regex = /\/first-class-lounge-enquiry-success/gi
    const dataLayer = window.dataLayer || []

    if (urlMatchesKeyword(regex)) {
      trackEvent('lead-pjc-ContactForm', 'Submit', 'First Class Lounge')
      trackFbEvent('Lead')
      dataLayer.push({ event: 'enquire_form_submit', form_name: 'First Class Lounge' })
    }
  }

  trackNewsletterFormEvent () {
    const regex = /\/sign-up-newsletter-success/gi

    if (urlMatchesKeyword(regex)) {
      trackEvent('lead-pjc-NewsletterSubscription', 'Submit', 'Newsletter sign up')
      trackFbEvent('CompleteRegistration')
      // dataLayer.push({ event: 'subscribe_contact', contact_list: 'Newsletter sign up' })
    }
  }

  showModalOnUrl () {
    if (typeof window !== 'undefined') {
      const params = new URLSearchParams(window.location.search)
      const modal = params.get('modal')

      if (modal === 'register') {
        this.setState({
          modal: true
        })
      }
    }
  }

  render () {
    return (
      <>
        <Notices />
        <Toolbar />
        <Header />

        <main role="main">
          {this.props.children}
        </main>

        <Newsletter onClick={this.toggleModal.bind(this)} />

        <Footer />
        {/* <Cookie /> */}

        {this.state.modal && (
          <Register
            onClick={() => this.toggleModal()}
          />
        )}
      </>
    )
  }
}

export default connect(null, { storeWindowSize })(Main)

Main.propTypes = {
  location: PropTypes.string,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired,
  storeWindowSize: PropTypes.func
}
